import Axios from "@/helpers/axios";

export default {
    GET_PROFILE: (context) => {
        return Axios.get(`/user/profile`).then(res => {
            context.commit("SET_PROFILE", res.data);
            return res;
        });
    },
    GET_LIB: (context, reload) => {
        reload = true;
        if (reload) {
            localStorage.removeItem('lib');
        }
        let localLib = JSON.parse(localStorage.getItem('lib'));

        if (!localLib || ((new Date()).getTime() - localLib.create) / 1000 > 60 * 60) {
            return  Axios.get(`/lib?bilaskra_package_lib=1`).then(res => {
                res.data.create = new Date().getTime();
                context.commit("SET_LIB", res.data);

                if ('localStorage' in window && window.localStorage !== null) {
                    localStorage.setItem('lib', JSON.stringify(res.data));
                }
            });
        } else {
            context.commit("SET_LIB", localLib);
        }
    },
    GET_NEW_CARS: (context, payload) => {
        Axios.post(`/new-cars/get`, payload).then(res => {
            console.log(res);
        });
    },
    GET_FAVORITES: (context, payload) => {
        return Axios.post(`/favorites/get`, payload).then(res => {
            context.commit("SET_FAV", res.data);
        });
    },
    GET_NOTIFICATIONS: (context) => {
        return Axios.post(`/notifications/get-notifications`).then(res => {
            context.commit('SET_NOTIFICATIONS', res.data);
        });
    },
    LOGIN: (context, payload) => {
        return Axios.post(`/user/login`, {
            email: payload.email,
            password: payload.password
        });
    },
    FB_LOGIN: (context, {token, link}) => {
        let d = new FormData();
        d.set("token", token);
        if (link) {
            d.set("link", link);
        }

        return Axios.post(`/user/fb-login`,d);
    },
    LOGOUT: () => {
        return Axios.get(`/user/logout`);
    },
    MANAGE_NOTIFICATIONS: (content, payload) => {
        Axios.post('favorites/manage-notifications', payload).then(() => {
        });
    },
    SAVE_STATISTIC:(content, payload) => {
        Axios.post("new-cars/save-stat",payload).then(() => {

        })
    },
    GET_FOOTER:(context) => {
        Axios.get("footer").then((res) => {
            context.commit("SET_FOOTER_DATA",res.data)
        })
    }
}